export default {
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
}


// WEBPACK FOOTER //
// ./src/components/Employees/EmployeesGrid/styles.js